import React, { useState } from 'react';

import { IPpdPricesDto } from '@r1-frontend/api-domru/ppd-service/dto/IPpdPricesDto';
import { ICurrentCity } from '@r1-frontend/entities/City/models/ICurrentCity';

import type { TDispatch } from '~/src/features/center/BlockInfo';
import ChooserBlock from '~/src/features/center/ChooserBlock';
import { FIRST_ELEMENT } from '~/src/features/center/constants/ordinary';
import Form from '~/src/features/center/Form';
import { useEffectActive } from '~/src/features/center/hooks/useEffectActive';
import Offer from '~/src/features/center/Offer';
import { getWithoutLineTranslation } from '~/src/features/center/utils';

import * as ST from './styled';

interface IDataInfo {
    city: ICurrentCity,
    setActivePriceBlock: TDispatch,
    blockPriceRef: React.RefObject<HTMLDivElement>,
    title: string,
    text: string,
    textBottom: string,
    bgGradientPrice: string,
    dataPricesFiltered: IPpdPricesDto[],
}

const BlockPrice: React.FC<IDataInfo> = ({
    setActivePriceBlock,
    blockPriceRef,
    title,
    text,
    textBottom,
    bgGradientPrice,
    city,
    dataPricesFiltered,
}) => {
    const [selected, setSelected] = useState(FIRST_ELEMENT);
    useEffectActive(setActivePriceBlock);

    return (
        <ST.PriceBlockContainer ref={blockPriceRef}>
            <ST.Wrapper data-test={'wrapper'} bgGradientPrice={ bgGradientPrice }>
                <ST.Title data-test={'title'}>{title}</ST.Title>
                <ST.Text data-test={'text'}>{text}</ST.Text>
                <ST.BottomWrapper>
                    <ST.RadioWrapper>
                        <ChooserBlock
                            dataPricesFiltered={dataPricesFiltered}
                            selected={selected}
                            setSelected={setSelected}
                        />
                    </ST.RadioWrapper>
                    <ST.BottomContainer>
                        <Form
                            city={city}
                            withInputName={true}
                            withLegalText={false}
                            textButton={'Перезвонить мне'}
                            label={`${getWithoutLineTranslation(title)} | ${dataPricesFiltered[selected]?.nameForLanding}`}
                        />
                        <ST.OfferWrapper>
                            <Offer/>
                        </ST.OfferWrapper>
                        <ST.BottomBlock data-test={'button'} dangerouslySetInnerHTML={{ __html: `${ textBottom }` }}/>
                    </ST.BottomContainer>
                </ST.BottomWrapper>
            </ST.Wrapper>
        </ST.PriceBlockContainer>
    );
};

export default BlockPrice;
